const data = {
    "Search Trips": "Search Trips",
    "Enter Trip Number": "Enter Trip Number",
    "Trip number": "Trip number",
    "Search Organization": "Search Organization",
    "Enter Organization Name": "Enter Organization Name",
    "Filter by": "Filter by",
    "Customs Border": "Customs Border",
    "Trip Type": "Trip Type",
    "All Carriers": "All Carriers",
    "All Ports": "All Ports",
    "Trip Status": "Trip Status",
    "Pending": "Pending",
    "Dispatch": "Dispatch",
    "Ready for Dispatch": "Ready for Dispatch",
    "Awaiting Customs": "Awaiting Customs",
    "In Transit": "In Transit",
    "Released": "Released",
    "Sent": "Sent",
    "Accepted": "Accepted",
    "Rejected": "Rejected",
    "Deleted": "Deleted",
    "Arrived": "Arrived",
    "Draft": "Draft",
    "Arrived": "Arrived",
    "Active": "Active",
    "Archived": "Archived",
    "Cancel": "Cancel",
    "Trip": "Trip",
    "Trips": "Trips",
    "Trip #": "Trip #",
    "New Trip": "New Trip",
    "Save Trip": "Save Trip",
    "Dashboard": "Dashboard",
    "Account Settings": "Account Settings",
    "Member Settings": "Member Settings",
    "Profile": "Profile",
    "Notifications": "Notifications",
    "Basic Information": "Basic Information",
    "Sign out": "Sign out",
    "First Name": "First Name",
    "Last Name": "Last Name",
    "Phone Number": "Phone Number",
    "Update Profile": "Update Profile",
    "Email Address": "Email Address",
    "Reset Password": "Reset Password",
    "Check your Inbox": "Check your Inbox",
    "Enter a valid email address": "Enter a valid email address",
    "Optima Commerce is the leading E-manifest solution provider for US & Canada.": "Optima Commerce is the leading E-manifest solution provider for US & Canada.",
    "Text Password Reset": `We'll send password reset instructions to your email address. If no email is
    received within ten minutes, check your spam folder or try again.`,
    "Registered email address": "Registered email address",
    "email is a required field": "Email is a required field",
    "First Name is a required field": "First Name is a required field",
    "Name is a required field": "Name is a required field",
    "Last Name is a required field": "Last Name is a required field",
    "Organization Name is a required field": "Organization Name is a required field",
    "Phone Number is a required field": "Phone Number is a required field",
    "VIN is a required field": "VIN is a required field",
    "Must have at least 8 characters": "Must have at least 8 characters",
    "Organization Name must be at least 3 characters": "Organization Name must be at least 3 characters",
    "We've sent password reset instructions to your email address. If no email is received within ten minutes, check that the submitted address is correct.": "We've sent password reset instructions to your email address. If no email is received within ten minutes, check that the submitted address is correct.",
    "Today": "Today",
    "This Week": "This week",
    "This Month": "This month",
    "Phone number must be exactly 10 numbers": "Phone number must be exactly 10 numbers",
    "Page": "Page",
    "to": "to",
    "of": "of",
    "or": "or",
    "No rows to show": "No rows to show",
    "No options to show": "No options to show",
    "No commodities to show": "No commodities to show",
    "Drag n’ Drop your CSV file here": "Drag n’ Drop your CSV file here",
    "browse file": "browse file",
    "Don't have a template": "Don't have a template",
    "Download here": "Download here",
    "accepted": "Accepted",
    "uploading": "Uploading",
    "Bulk upload": "Bulk upload",
    //Catalogs Menu
    "Organization": "Organization",
    "Catalogs": "Catalogs",
    "Parties": "Parties",
    "Commodities": "Commodities",
    "Carriers": "Carriers",
    "Select Carrier": "Select Carrier",
    "Find Carrier": "Find Carrier",
    "Conveyances": "Conveyances",
    "Conveyance": "Conveyance",
    "Equipments": "Equipments",
    "Drivers": "Drivers",
    "Passengers": "Passengers",
    "Passenger": "Passenger",
    //Parties
    "New Party": "New Party",
    "Info": "Info",
    "Name": "Name",
    "Phone": "Phone",
    "Address": "Address",
    "Postal Code": "Postal Code",
    "Country": "Country",
    "Select": "Select",
    "State": "State",
    "City": "City",
    "Shipper": "Shipper",
    "Contact": "Contact",
    "Email": "Email",
    "Consignee": "Consignee",
    "Required fields": "Required fields",
    "Party": "Party",
    "New": "New",
    "Enabled": "Enabled",
    "Disabled": "Disabled",
    "Save": "Save",
    "Delete": "Delete",
    "Commodity Description": "Commodity Description",
    "Quantity": "Quantity",
    "Quantity UOM": "Quantity UOM",
    "Commodity Code": "Commodity Code",
    "Gross Weight": "Gross Weight",
    "Weight UOM": "Weight UOM",
    "Hazmat Info": "Hazmat Info",
    "Hazmat Class": "Hazmat Class",
    "Hazmat UN Code": "Hazmat UN Code",
    "Additional Info": "Additional Info",
    "HTS": "HTS",
    "Value": "Value",
    "Commodity": "Commodity",
    "Marks And Numbers": "Marks And Numbers",
    "Owner": "Owner",
    "Physical Address Info": "Physical Address Info",
    "Contact Information": "Contact Information",
    //Carriers
    "Carriers": "Carriers",
    "Carrier": "Carrier",
    "Carrier Name": "Carrier Name",
    "SCAC": "SCAC",
    "Canadian SCAC": "Canadian SCAC",
    "Dot Number": "Dot Number",
    "Federal Tax ID": "Federal Tax ID",
    "Location": "Location",
    "Physical Address": "Physical Address",
    "Permissions": "Permissions",
    "Allow Conveyance change": "Allow Conveyance change",
    "Allow Equipment change": "Allow Equipment change",
    "Allow Driver change": "Allow Driver change",
    "Search Organization": "Search Organization",
    "Allowed Organizations": "Allowed Organizations",
    "Carrier is a required field": "Carrier is a required field",
    "scac is a required field": "scac is a required field",
    "Dot Number is a required field": "DOT Number is a required field",
    "Carrier Code Text": "SCAC or Canadian SCAC is required.",
    "At least SCAC or CASCAC is required": "At least SCAC or CASCAC is required",
    //Conveyance
    "Conveyance": "Conveyance",
    "Type": "Type",
    "Select Type": "Select Type",
    "Conveyance Number": "Conveyance Number",
    "Primary Plate": "Primary Plate",
    "VIN": "VIN",
    "Settings": "Settings",
    "Organization Settings": "Organization Settings",
    "Default Driver": "Default Driver",
    "Default Equipment(s)": "Default Equipment(s)",
    "Secondary Info": "Secondary Info",
    "Make": "Make",
    "Model Year": "Model Year",
    "Style": "Style",
    "Secondary Plate": "Secondary Plate",
    "Secondary Plate Country": "Secondary Plate Country",
    "Tracking IMEI": "Tracking IMEI",
    "Insurer": "Insurer",
    "Insurance": "Insurance",
    "Policy Insurance": "Policy Insurance",
    "Policy Number": "Policy Number",
    "Policy Issue Date": "Policy Issue Date",
    "Coverage Amount": "Coverage Amount",
    "Search": "Search",
    "Conveyance Type is a required field": "Conveyance Type is a required field",
    "Conveyance Number is a required field": "Conveyance Number is a required field",
    "Primary Plate is a required field": "Primary Plate is a required field",
    "Primary Plate Country is a required field": "Primary Plate Country is a required field",
    //Equipments
    "Equipment": "Equipment",
    "Equipment Type": "Equipment Type",
    "Equipment Number": "Equipment Number",
    "Leased": "Leased",
    "Equipment Type is a required field": "Equipment Type is a required field",
    "Equipment Number is a required field": "Equipment Number is a required field",
    "Select country": "Select country",
    "Enter Country": "Enter Country",
    "Select State": "Select State",
    "Select state": "Select state",
    "Select Make": "Select Make",
    "Select Secondary Plate Country": "Select Secondary Plate Country",
    //Drivers
    "Driver": "Driver",
    "Middle Name": "Middle Name",
    "Date of Birth": "Date of Birth",
    "Gender": "Gender",
    "Male": "Male",
    "Female": "Female",
    "Citizenship": "Citizenship",
    "License Number": "License Number",
    "License Country": "License Country",
    "License State/Province": "License State/Province",
    "Location Code": "Location Code",
    "Reference": "Reference",
    "Travel Documents": "Travel Documents",
    "Travel Doc Text": "At least one travel document is required.",
    "Passport": "Passport",
    "Passport Country": "Passport Country",
    "FAST": "FAST",
    "Border Crossing": "Border Crossing",
    "Border Crossing Card": "Border Crossing Card",
    "Permanent Resident": "Permanent Resident",
    "NEXUS": "NEXUS",
    "Passport Card": "Passport Card",
    "Enhanced Driver's License": "Enhanced Driver's License",
    "US Visa": "US Visa",
    "Contact Info": "Contact Info",
    "Date of Birth is a required field": "Date of Birth is a required field",
    "Citizenship is a required field": "Citizenship is a required field",
    "License Number is a required field": "License Number is a required field",
    "License Country is a required field": "License Country is a required field",
    "License State is a required field": "License State is a required field",
    "Travel Document": "Travel Document",
    "Select travel document": "Select travel document",
    "Add another document": "Add another document",
    "At least one travel document is required": "At least one travel document is required",
    "Travel document selection cannot be empty": "Travel document selection cannot be empty",
    "Passport Country is required if passport is selected": "Passport Country is required if passport is selected",
    "Passport Number is required if passport is selected": "Passport Number is required if passport is selected",
    "FAST Card Number is required if FAST is selected": "FAST Card Number is required if FAST is selected",
    "Border Crossing Card Number is required if Border Crossing Card is selected": "Border Crossing Card Number is required if Border Crossing Card is selected",
    "Permanent Resident Card Number is required if Permanent Resident Card is selected": "Permanent Resident Card Number is required if Permanent Resident Card is selected",
    "NEXUS is required if NEXUS is selected": "NEXUS is required if NEXUS is selected",
    "Enhanced License is required if Enhanced License is selected": "Enhanced License is required if Enhanced License is selected",
    "US Visa Number is required if US Visa is selected": "US Visa Number is required if US Visa is selected",
    "Hazmat Contact Info": "Hazmat Contact Info",
    "Hazmat Contact Name": "Hazmat Contact Name",
    "Hazmat Contact Phone": "Hazmat Contact Phone",
    "Hazmat Contact Email": "Hazmat Contact Email",
    //Passenger
    "Passengers": "Passengers",
    //Trip
    "Trip Info": "Trip Info",
    "Trip Information": "Trip Information",
    "Estimated Arrival": "Estimated Arrival",
    "Arrival Port": "Arrival Port",
    "Enter Arrival port name or code": "Enter Arrival port name or code",
    "Carrier Information": "Carrier Information",
    "Add": "Add",
    "Enter Conveyance name": "Enter Conveyance name",
    "Enter Equipment name": "Enter Equipment name",
    "Enter Driver name": "Enter Driver name",
    "Generate": "Generate",
    "Enter Carrier name": "Enter Carrier name",
    "Enter port name or code": "Enter port name or code",
    "Trip check data": "Trip can't be saved, check which data is incorrect or missing.",
    "No shipments added": "No shipments have been added",
    "Add Shipments": "Add Shipments",
    "Select carrier first": "You must select a carrier first.",
    "Import Shipments from CSV": "Import Shipments from CSV",
    "Add shipments text": "You can add all shipments you need on this trip.",
    "Required only for empty shipments. Specifies the trip destination.": "Required only for empty shipments. Specifies the trip destination.",
    "Shipments": "Shipments",
    "Shipments will be removed": "The shipments selected will be removed.",
    "Yes, Delete shipments": "Yes, Delete shipments",
    "Are you sure to do this?": "Are you sure to do this?",
    "Error deleting shipments": "There was an error trying to deleting selected shipments.",
    "Please select shipments to delete": "Please select the shipments you want to delete.",
    "Deletions selected shipments": "Deletion of selected shipments is complete.",
    "New Commodity": "New Commodity",
    "Required fields commodity": "Please enter the required fields before insert a commodity",
    "Type": "Type",
    "Choose Type": "Choose Type",
    "Entry": "Entry",
    "Enter Port of Lading name": "Enter Port of Lading name",
    "Enter Port of Lading": "Enter Port of Lading",
    "One is required": "One is required",
    "Conveyance must have insurance info": "Conveyance must have insurance info",
    "Hazmat": "Hazmat",
    "Bulk Actions": "Bulk Actions",
    "Delete commodities": "Delete commodities",
    "Add Commodity": "Add Commodity",
    "Enter Shipper": "Enter Shipper",
    "Enter Consignee": "Enter Consignee",
    'Trip updated successfully.': 'Trip updated successfully.',
    'There was an error trying to update the trip.': 'There was an error trying to update the trip.',
    "Enter SCN": "Enter SCN",
    "Enter Secondary Carrier": "Enter Secondary Carrier",
    "Secondary Carrier": "Secondary Carrier",
    "Sublocation Port": "Sublocation Port",
    "Destination Port": "Destination Port",
    "Enter Destination port name": "Enter Destination port name",
    "Enter Sublocation port name": "Enter Sublocation port name",
    "First select a destination port": "First select a destination port",
    "Outbound State": "Outbound State",
    "Enter state name": "Enter state name",
    "Enter Outbound state name": "Enter Outbound state name",
    "Outbound Port": "Outbound Port",
    "First select outbound state": "First select outbound state",
    "Firms Code": "Firms Code",
    "Enter Firms Code": "Enter Firms Code",
    "First select a US Port of Destination": "First select a Inbond Destination",
    "Consolidated Freight": "Consolidated Freight",
    "Enter Arrival Port": "Enter Arrival Port",
    "You can not have both MX to US and CA to US active at the same time": "You can not have both MX to US and CA to US active at the same time",
    "Documents in email": "Documents in email",
    //Commodities
    "Description": "Description",
    "New Shipment": "New Shipment",
    "Port of Lading": "Port of Lading",
    //Summary
    "Back to dashboard": "Back to dashboard",
    "Notes": "Notes",
    "Documents": "Documents",
    "Options": "Options",
    "Receipt": "Receipt",
    "Coversheet": "Coversheet",
    "Enlarged QR": "Enlarged QR",
    "Manifest": "Manifest",
    "7533": "7533",
    "7533Entry": "7533 (Entry)",
    "7523": "7523",
    "Send Trip": "Send Trip",
    "Summary": "Summary",
    "Arrival Details": "Arrival Details",
    "There are no conveyances to show": "There are no conveyances to show",
    "There are no equipments to show": "There are no equipments to show",
    "There are no drivers to show": "There are no drivers to show",
    "successfully deleted from this organization.": "successfully deleted from this organization.",
    "successfully sent for deletion.": "successfully sent for deletion.",
    "Do you want to delete this trip?": "Do you want to delete this trip?",
    "No, cancel": "No, cancel",
    "Yes, delete trip": "Yes, delete trip",
    "will be permanently deleted from your organization.": "will be permanently deleted from your organization.",
    "Shipments saved correctly.": "Shipments saved correctly.",
    "There was an error trying to upload shipments.": "There was an error trying to upload shipments.",
    "WARNING": "WARNING:",
    "Some shipments are rejected:": "Some shipments are rejected:",
    "You can add all shipments you need on this trip.": "You can add all shipments you need on this trip.",
    "Trip copied successfully.": "Trip copied successfully.",
    "There was an error trying to copy the trip.": "There was an error trying to copy the trip.",
    'Copy Trip Details': 'Copy Trip Details',
    "Carrier is a required field": "Carrier is a required field",
    "Arrival Port is a required field": "Arrival Port is a required field",
    "Trip number already taken, try another one.": "Trip number already taken, try another one.",
    "Trip Number is a required field": "Trip Number is a required field",
    "Trip Number must be at least 3 characters": "Trip Number must be at least 3 characters",
    "Conveyance is a required field": "Conveyance is a required field",
    "At least one Driver must be specified": "At least one Driver must be specified",
    "Type is a required field": "Type is a required field",
    "SCN is a required field": "SCN is a required field",
    "SCN must be at least 3 characters": "SCN must be at least 3 characters",
    "Shipper is a required field": "Shipper is a required field",
    "Consignee is a required field": "Consignee is a required field",
    "Port of Lading is a required field": "Port of Lading is a required field",
    "Entry # must be at least 3 characters": "Entry # must be at least 3 characters",
    "No matches found": "No matches found",
    "Search Shipment": "Search Shipment",
    "Find SCN": "Find SCN",
    "Filter by Status": "Filter by Status",
    "There are no passengers to show": "There are no passengers to show",
    "SCN to search": "SCN to search",
    "Passenger(s)": "Passenger(s)",
    //Notifications
    "Events": "Events",
    "Shipment": "Shipment",
    "No messages yet": "No messages yet",
    "Available Notifications": "Once the trip is sent to CBP, all notifications will be available here.",
    "Add Notifications Emails": "Add emails to receive notifications of trips created by you.",
    "Enter email separated by commas": "Enter email separated by commas",
    "Update Emails": "Update Emails",
    "Trip Events": "Trip Events",
    "Trip Accepted by CBP": "Trip Accepted by CBP",
    "Trip Arrived by CBP": "Trip Arrived by CBP",
    "Trip Released by CBP": "Trip Released by CBP",
    "Trip Deleted by CBP": "Trip Deleted by CBP",
    "Trip Rejected by CBP": "Trip Rejected by CBP",
    "Shipment Events": "Shipment Events",
    "Entry on file": "Entry on file",
    "QP on file": "QP on file",
    "Entry not on file": "Entry not on file",
    "Entry port code mismatch": "Entry port code mismatch",
    "Overage": "Overage",
    "Shortage": "Shortage",
    "Notification Emails": "Notification Emails",
    "Arrival Date": "Arrival Date",
    "UOM": "UOM",
    "Gross Weight UOM": "Gross Weight UOM",
    "Edit Shipment": "Edit Shipment",
    "Origin": "Origin",
    "Status": "Status",
    "On File": "On File",
    "Send as": "Send as",
    "H Tariff": "H Tariff",
    "Truck": "Truck",
    "No notifications to show": "No notifications to show",
    "Select a notification to view the full message.": "Select a notification to view the full message.",
    "Created": "Created",
    //Tenant
    "The role was updated successfully!": "The role was updated successfully!",
    "It was a problem updating the role!": "It was a problem updating the role!",
    "New Tenant": "New Tenant",
    "Tenant": "Tenant",
    "Tenant Name": "Tenant Name",
    "Allowed Domains": "Allowed Domains",
    "Tenant Address": "Tenant Address",
    "Street Address": "Street Address",
    "Tenant Settings": "Tenant Settings",
    "Primary Color": "Primary Color",
    "Secondary Color": "Secondary Color",
    "Logo": "Logo",
    "Upload a file": "Upload a file",
    "Tenants": "Tenants",
    "Invite Members": "Invite Members",
    "Invite Member": "Invite Member",
    "Invite Members Collaborate": "Invite new members to your organization",
    "Enter email separated by commas": "Enter email separated by commas",
    "Enter some emails": "Enter some emails",
    "Invite member now": "Invite member now",
    "Invite": "Invite",
    "Members": "Members",
    "Invited to join": "Invited to join",
    "Resend invite": "Resend invite",
    "Tenant Name is a required field": "Tenant Name is a required field",
    "url is a required field": "url is a required field",
    "Street Address is a required field": "Street Address is a required field",
    "Address #1 is a required field": "Address #1 is a required field",
    "City is a required field": "City is a required field",
    "State is a required field": "State is a required field",
    "Zip Code is a required field": "Zip Code is a required field",
    "Country is a required field": "Country is a required field",
    "Invalid phone number": "Invalid phone number",
    "Contact Email must be a valid email": "Contact Email must be a valid email",
    //Settings
    "Organization Name": "Organization Name",
    "Save Changes": "Save Changes",
    "Primary Contact Info": "Primary Contact Info",
    "Owner contact information": "Owner contact information",
    "Organization Address": "Organization Address",
    "FTP Settings": "FTP Settings",
    "Optima 3 identifier": "Optima 3 identifier",
    "FTP Code": "FTP Code",
    "Auto Send": "Auto Send",
    "Carrier Settings": "Carrier Settings",
    "Search Carrier": "Search Carrier",
    "Enter Carrier Name": "Enter Carrier Name",
    "My Carriers": "My Carriers",
    "Organization updated successfully": "Organization updated successfully",
    "Error Updating Organizations": "There was an error when trying to update your organization settings",
    "New Organization": "New Organization",
    "saved successfully": "saved successfully",
    "There was an error adding a Organization.": "There was an error adding a Organization.",
    "The invites have been sent successfully.": "The invites have been sent successfully.",
    "Organizations": "Organizations",
    "Status Settings": "Status Settings",
    "Selected Organizations": "Selected Organizations",
    "ACTIVATE": "ACTIVATE",
    "DEACTIVATE": "DEACTIVATE",
    "ORGANIZATIONS": "ORGANIZATIONS",
    "Clear": "Clear",
    "Apply Change": "Apply Change",
    "Search User": "Search User",
    "Enter User": "Enter User",
    "Selected Users": "Selected Users",
    "USERS": "USERS",
    "Send Instructions": "Send Instructions",
    "Back to Sign in": "Back to Sign in",
    "Don´t have an account?": "Don´t have an account?",
    "Create one": "Create one",
    "We´ll help you reset": "We´ll help you reset it and get back on track. Enter your email to reset your password.",
    "Password": "Password",
    "More than 8 characters": "More than 8 characters",
    "Join to": "Join to",
    "Loading": "Loading",
    "By signing up, I accept the": "By signing up, I accept the",
    "Terms of Use": "Terms of use",
    "and": "and",
    "Privacy Policy": "Privacy Policy",
    "Sign up and Join": "Sign up and Join",
    "Sign Up": "Sign Up",
    "Sign in": "Sing in",
    "Verify email": "Verify email",
    "Email is required": "Email is required",
    "Resend code": "Resend code",
    "Make sure to keep this window open": "Make sure to keep this window open while you check your inbox",
    "Please check your email inbox": "Please check your email inbox. A verification code should be arriving soon!",
    "We just sent a six-digit code": "We just sent a six-digit code to your email. Enter the code below to confirm your email address.",
    "The Page you are looking for doesn´t exist": "The Page you are looking for doesn´t exist or an other error ocurred. Go back to home.",
    "The user has been removed successfully.": "The user has been removed successfully.",
    "The invite has been removed successfully.": "The invite has been removed successfully.",
    "The invites have been sent successfully.": "The invites have been sent successfully.",
    "Page not found": "Page not found",
    "Return to Home": "Return to Home",
    "Tools": "Tools",
    "Channels": "Channels",
    "Trip Control": "Trip Control",
    "Unassigned Tenants": "Unassigned Tenants",
    "Search Field": "Search Field",
    "Support": "Support",
    "Search Tenants": "Search Tenants",
    "Search tenants": "Search tenants",
    "Search Tenant": "Search Tenant",
    "Organization ID": "Organization ID",
    "Selected tenants": "Selected tenants",
    "Tenant users": "Tenant users",
    "Please select a user": "Please select a user",
    "Selected Language": "Selected Language",
    "Email Notifications": "Email Notifications",
    "EMAIL": "EMAIL",
    "ACTIVE": "ACTIVE",
    "INACTIVE": "INACTIVE",
    "Expired": "Expired",
    "Message": "Message",
    "Active since": "Active since",
    "Expires on": "Expires on",
    "Generate new key": "Generate new key",
    "Generate key": "Generate key",
    "Save Key": "Save Key",
    "Headers Webhook": "Headers Webhook",
    "Trip ID": "Trip ID",
    "EDI Type": "EDI Type",
    "EDI Status": "EDI Status",
    "Error Message": "Error Message",
    "Default Information": "Default Information",
    "To US": "To US",
    "To CA": "To CA",
    "Commodity UOM": "Commodity UOM",
    "Consignee State": "Consignee State",
    "Select UOM": "Select UOM",
    //Logs
    "Search Log Type": "Search Log Type",
    "Organization Logs": "Organization Logs",
    "User Logs": "User Logs",
    "User Invite Logs": "User Invite Logs",
    "Trip Logs": "Trip Logs",
    "Shipment Logs": "Shipment Logs",
    "Party Logs": "Party Logs",
    "Carrier Logs": "Carrier Logs",
    "Conveyance Logs": "Conveyance Logs",
    "Equipment Logs": "Equipment Logs",
    "Driver Logs": "Driver Logs",
    "Passenger Logs": "Passenger Logs",
    "Action": "Action",
    "Entity": "Entity",
    "Date": "Date",
    "Success": "Success",
    //Notifications
    "Search Notification": "Search Notification",
    "Title": "Title",
    "Portal": "Portal",
    "Informative": "Informative",
    "Default Message": "Default Message",
    "Search default message": "Search default message",
    "English Message": "English Message",
    "Spanish Message": "Spanish Message",
    "Link title": "Link title",
    "Link": "Link",
    "Expiration Date": "Expiration Date",
    "Optima Notifications": "Optima Notifications",
    //Reports
    "General Report": "General Report",
    "Monthly Report": "Monthly Report",
    "Error loading trip report. Please try a shorter date range.": "Error loading trip report. Please try a shorter date range.",
    //Conveyance
    "Enter Type": "Enter Type",
    "Primary Plate State": "Primary Plate State",
    "Secondary Plate Country": "Secondary Plate Country",
    "Secondary Plate State": "Secondary Plate State",
    "Seals": "Seals",
    "IIT": "IIT",
    "Has IIT?": "Has IIT?",
    "Has IIT": "Has IIT",
    "IIT Type": "IIT Type",
    "Seals and IIT Info": "Seals and IIT Info",
    "Edit": "Edit",
    "Copy": "Copy",
    "Edit Trip Details": "Edit Trip Details",
    "Save Changes": "Save Changes",
    "Change": "Change",
    "Inactive": "Draft",
    "Accepted by CBP": "Accepted by CBP",
    "Trip notes saved successfully.": "Trip notes saved successfully.",
    "There was an error saving this Trip notes.": "There was an error saving this Trip notes.",
    "Notes relevant to this trip": "Notes relevant to this trip",
    "Up to 160 characters": "Up to 160 characters",
    "Add Seals": "Add Seals and IIT",
    "View": "View",
    "Remove": "Remove",
    "Edit Seals": "Edit Seals",
    "New Conveyance": "New Conveyance",
    "Save Conveyance": "Save Conveyance",
    "New Equipment": "New Equipment",
    "Last Update": "Last Update",
    "Add IIT": "Add IIT",
    "Yes, Send as ADD the selected shipments": "Yes, Send as ADD the selected shipments",
    "Shipments will be marked as ADD": "Shipments will be marked as ADD",
    "Yes, Send as CHANGE the selected shipments": "Yes, Send as CHANGE the selected shipments",
    "Shipments will be marked as CHANGE": "Shipments will be marked as CHANGE",
    "Yes, Send as DELETE the selected shipments": "Yes, Send as DELETE the selected shipments",
    "Shipments will be marked as DELETE": "Shipments will be marked as DELETE",
    "Yes, Clear Send as the selected shipments": "Yes, Clear Send as the selected shipments",
    "Send as will be clear": "Send as will be clear",
    "Delete Shipments": "Delete Shipments",
    "Save Shipment": "Save Shipment",
    "In Charge": "In Charge",
    "Send as ADD": "Send as ADD",
    "Send as CHANGE": "Send as CHANGE",
    "Send as DELETE": "Send as DELETE",
    "Clear Send as": "Clear Send as",
    "All Shipments": "All Shipments",
    "Please resend Trip": "This Trip has information not yet sent to Customs, and you might have issues crossing with its receipt. Please resend the Trip.",
    "Basic Information": "Basic Information",
    "FTP": "FTP",
    "Contacts": "Contacts",
    "Mobile": "Mobile",
    "Position": "Position",
    "Add Contact": "Add Contact",
    "Contact Information": "Contact Information",
    "Contact Name": "Contact Name",
    "Contact Information to Show": "Contact Information to Show",
    "contactName is a required field": "contactName is a required field",
    "Need Help?": "Need Help?",
    "User Information": "User Information",
    "Auto Send": "Auto Send",
    "Current Month Trips": "Current Month Trips",
    "Last Month Trips": "Last Month Trips",
    "In Bond Trips": "In Bond Trips",
    "Section 321 Trips": "Section 321 Trips",
    "Current Year Trips": "Current Year Trips",
    "Last Year Trips": "Last Year Trips",
    "CBP is experiencing problems with their acceptance messages nationwide. This is the third incident today of this kind. The Ticket Number is [---].": "CBP is experiencing problems with their acceptance messages nationwide. This is the third incident today of this kind. The Ticket Number is [---].",
    "CBP is experiencing problems with their acceptance messages nationwide. This is the third incident today of this kind.  Ticket not issued yet.": "CBP is experiencing problems with their acceptance messages nationwide. This is the third incident today of this kind.  Ticket not issued yet.",
    "CBP is experiencing problems with intermittent interruptions with output messages being generated and sent out. The Ticket Number is [---]. Expect a delay of 15-25 minutes to get some Accepted messages.": "CBP is experiencing problems with intermittent interruptions with output messages being generated and sent out. The Ticket Number is [---]. Expect a delay of 15-25 minutes to get some Accepted messages.",
    "A few minutes ago, CBP experienced an interruption with output messages. ACE system has already been reestablished. Ticket number is [---].": "A few minutes ago, CBP experienced an interruption with output messages. ACE system has already been reestablished. Ticket number is [---].",
    "CBP is currently experiencing a delay to process and submit their messages. Due to maintenance in their system TICKET .": "CBP is currently experiencing a delay to process and submit their messages. Due to maintenance in their system TICKET .",
    "SCN already taken.": "SCN already taken.",
    "Verify your email address": "Verify your email address",
    "Start creating your first trip": "Start creating your first trip",
    "Any new trip you create will be displayed here.": "Any new trip you create will be displayed here.",
    "Please complete the trip, Driver and Conveyance are required": "Please complete the trip, Driver and Conveyance are required",
    "My SCACs": "My SCACs",
    "Conveyance Only": "Conveyance Only",
    "Empty Equipment": "Empty Equipment",
    "Regular": "Regular",
    "Sent to CBP": "Sent to CBP",
    "Delete Trip": "Delete Trip",
    "Empty": "Empty",
    "Bond Info": "Bond Info",
    //STATUS
    "Inactive": "Inactive",
    "EDI File Ready to Send": "EDI File Ready to Send",
    "EDI File Ready to Send For Deletion": "EDI File Ready to Send For Deletion",
    "EDI File Ready to Send For Edition": "EDI File Ready to Send For Edition",
    "Sent To CBP": "Sent To CBP",
    "Sent For Deletion to CBP": "Sent For Deletion to CBP",
    "Sent For Edition to CBP": "Sent For Edition to CBP",
    "Received by CBP": "Received by CBP",
    "Syntax Rejected": "Syntax Rejected",
    "Accepted by CBP": "Accepted by CBP",
    "Rejected by CBP": "Rejected by CBP",
    "Deletion Accepted by CBP": "Deletion Accepted by CBP",
    "Deletion Rejected by CBP": "Deletion Rejected by CBP",
    "Edition Accepted by CBP": "Edition Accepted by CBP",
    "Edition Rejected by CBP": "Edition Rejected by CBP",
    "Arrived": "Arrived",
    "Released": "Released",
    "Entry On File": "Entry On File",
    "Entry Not On File": "Entry Not On File",
    "Deletion Accepted": "Deletion Accepted",
    "Deletion Rejected": "Deletion Rejected",
    "Edition Accepted": "Edition Accepted",
    "Edition Rejected": "Edition Rejected",
    //Send As Options
    "Original": "Original",
    "Preliminary": "Preliminary",
    "In-transit": "In-transit",
    "Amendment": "Amendment",
    "Delete": "Delete",
    //350 EVENTS
    "Trip arrived by CBP": "Trip arrived",
    "Cancel Truck Arrival": "Cancel Truck Arrival",
    "Carrier does not possess valid U.S operating authority": "Carrier does not possess valid U.S operating authority",
    "Carrier has an Out of Service order against it": "Carrier has an Out of Service order against it",
    "Safety score indicates inspection is warranted": "Safety score indicates inspection is warranted",
    "Carrier check not preformed, data not available at this time": "Carrier check not preformed, data not available at this time",
    "Carrier's current insurance does not meet the minimum level or better": "Carrier's current insurance does not meet the minimum level or better",
    "Carrier data not found in FMCSA systems": "Carrier data not found in FMCSA systems",
    "Driver check not preformed, data not available at this time": "Driver check not preformed, data not available at this time",
    "Driver does not have proper CDL endorsements for HAZMAT cargo": "Driver does not have proper CDL endorsements for HAZMAT cargo",
    "Driver does not have valid/current CDL or equivalent (MX or CA)": "Driver does not have valid/current CDL or equivalent (MX or CA)",
    "Trailer check not preformed, data not available at this time": "Trailer check not preformed, data not available at this time",
    "No current CVSA decal on file. Please check visually": "No current CVSA decal on file. Please check visually",
    "Tractor check not preformed, data not available at this time": "Tractor check not preformed, data not available at this time",
    "Crew/passengers Held": "Crew/passengers Held",
    "Equipment Held": "Equipment Held",
    "Hold Conveyance": "Hold Conveyance",
    "Trip Held": "Trip Held",
    "Overdue Conveyance Arrival": "Overdue Conveyance Arrival",
    "Conveyance Released": "Conveyance Released",
    "Crew/Passengers Released": "Crew/Passengers Released",
    "Equipment Released": "Equipment Released",
    "Trip released by CBP": "Trip released",
    "Driver account information needs to be updated with country of driver's citizenship.": "Driver account information needs to be updated with country of driver's citizenship.",
    "Driver account information needs to be updated with an approved WHTI document.": "Driver account information needs to be updated with an approved WHTI document.",
    "Conveyance added by Customs": "Conveyance added by Customs",
    "Conveyance updated by Customs": "Conveyance updated by Customs",
    "Conveyance removed by Customs": "Conveyance removed by Customs",
    "Equipment added by Customs": "Equipment added by Customs",
    "Equipment updated by Customs": "Equipment updated by Customs",
    "Equipment removed by Customs": "Equipment removed by Customs",
    "Crew added by Customs": "Crew added by Customs",
    "Crew updated by Customs": "Crew updated by Customs",
    "Crew removed by Customs": "Crew removed by Customs",
    //
    "Search Trip Notification": "Search Trip Notification",
    "Selected Notifications": "Selected Notifications",
    "Search Shipment Notification": "Search Shipment Notification",
    "API Name": "API Name",
    "Client Secret": "Client Secret",
    "Generate key": "Generate Key",
    "Update Key": "Update Key",
    //Shipment Notifications
    "Duplicate in-bond request via QP, carrier's in-bond accepted": "Duplicate in-bond request via QP, carrier's in-bond accepted",
    "Arrival of in-bond-complete movement": "Arrival of in-bond-complete movement",
    "Arrival of in-bond-bill of lading": "Arrival of in-bond-bill of lading",
    "Arrival of in-bond-container": "Arrival of in-bond-container",
    "Master in-bond advisory": "Master in-bond advisory",
    "Entered: Intensive examination required": "Entered: Intensive examination required",
    "Released: Intensive examination completed": "Released: Intensive examination completed",
    "Entered and released: general examination": "Entered and released: general examination",
    "Customs hold removed at port of in-bond destination": "Customs hold removed at port of in-bond destination",
    "Customs hold placed at port of in-bond destination": "Customs hold placed at port of in-bond destination",
    "Customs hold placed at port of discharge": "Customs hold placed at port of discharge",
    "Customs hold removed at port of discharge": "Customs hold removed at port of discharge",
    "In-bond Movement Authorized: bill of Lading open": "In-bond Movement Authorized: bill of Lading open",
    "Bill of lading late in 5 days": "Bill of lading late in 5 days",
    "Bill of lading late": "Bill of lading late",
    "Pending elegible general order": "Pending elegible general order",
    "Ordered to general order": "Ordered to general order",
    "Seized": "Seized",
    "Sent to general order": "Sent to general order",
    "USDA Miscellaneous hold removed at port of in-bond destination": "USDA Miscellaneous hold removed at port of in-bond destination",
    "USDA miscellaneous hold placed at port of in-bond destination": "USDA miscellaneous hold placed at port of in-bond destination",
    "USDA miscellaneous hold placed at port of discharge": "USDA miscellaneous hold placed at port of discharge",
    "USDA miscellaneous hold removed at oprt of discharge": "USDA miscellaneous hold removed at oprt of discharge",
    "Other government agency hold removed at port of in-bond destination": "Other government agency hold removed at port of in-bond destination",
    "Other government agency hold placed at port of in-bond destination": "Other government agency hold placed at port of in-bond destination",
    "Other government agency hold placed at port of discharge": "Other government agency hold placed at port of discharge",
    "Other government agency hold removed at port of discharge ": "Other government agency hold removed at port of discharge ",
    "Override": "Override",
    "Entry cancelled": "Entry cancelled",
    "Export of in-bond-complete movement": "Export of in-bond-complete movement",
    "Export of in-bond-bill of lading": "Export of in-bond-bill of lading",
    "Export of in-bond-container": "Export of in-bond-container",
    "Overdue export": "Overdue export",
    "Change arrival of in-bond-complete movement": "Change arrival of in-bond-complete movement",
    "Change arrival of in-bond-bill of lading": "Change arrival of in-bond-bill of lading",
    "Change arrival of in-bond-container": "Change arrival of in-bond-container",
    "Entry processing hold": "Entry processing hold",
    "Entry processing hold removed": "Entry processing hold removed",
    "Change export of in-bond-complete movement": "Change export of in-bond-complete movement",
    "Change export of in-bond-bill of lading": "Change export of in-bond-bill of lading",
    "Change of export of in-bond-container": "Change of export of in-bond-container",
    "Delete arrival of in-bond by complete movement": "Delete arrival of in-bond by complete movement",
    "Delete arrival of in-bond-bill of lading": "Delete arrival of in-bond-bill of lading",
    "Delete arrival of in-bond-container": "Delete arrival of in-bond-container",
    "Delete export of in-bond-complete": "Delete export of in-bond-complete",
    "Delete export of in-bond-bill of lading": "Delete export of in-bond-bill of lading",
    "Delete export of in-bond-container": "Delete export of in-bond-container",
    "Bill on file": "Bill on file",
    "Intensive hold for USDA placed at port of discharge": "Intensive hold for USDA placed at port of discharge",
    "Inspection/document review fir USDA placed at the port of discharge": "Inspection/document review fir USDA placed at the port of discharge",
    "Fumigation hold for USDA placed at the port of discharge": "Fumigation hold for USDA placed at the port of discharge",
    "Intensive hold for USDA removed at port of discharge": "Intensive hold for USDA removed at port of discharge",
    "Inspection/document review for USDA removed at the port of discharge": "Inspection/document review for USDA removed at the port of discharge",
    "Fumigation hold for USDA removed at the port of discharge": "Fumigation hold for USDA removed at the port of discharge",
    "Intensive hold for USDA placed at port of in-bond destination": "Intensive hold for USDA placed at port of in-bond destination",
    "Inspection/document review for USDA placed at the port of in-bond destination": "Inspection/document review for USDA placed at the port of in-bond destination",
    "Fumigation hold for USDA placed at the port of in-bond destination": "Fumigation hold for USDA placed at the port of in-bond destination",
    "Intensive hold for USDA removed at port of in-bond destination": "Intensive hold for USDA removed at port of in-bond destination",
    "Inspection/document review for USDA removed at the port of in-bond destination": "Inspection/document review for USDA removed at the port of in-bond destination",
    "Fumigation hold for USDA removed at the port of in-bond destination": "Fumigation hold for USDA removed at the port of in-bond destination",
    "PN on file": "PN on file",
    "PN not on file": "PN not on file",
    "Carrier Selection Required": "Carrier Selection Required",
    "Select a carrier from 'Select Carrier' on the left to view the catalog.": "Select a carrier from 'Select Carrier' on the left to view the catalog.",
    "No matches found": "No matches found",
    "No shipments found with this information.": "No shipments found with this information.",
    "When applying changes, your user session will be reset.": "When applying changes, your user session will be reset.",
    "AcceptedShipments": "ACCEPTED",
    "SentShipments": "SENT",
    "RejectedShipments": "REJECTED",
    "DeletedShipments": "DELETED",
    "DraftShipments": "DRAFT",
    "Hazmat columns": "Hazmat columns (HM Class and HM UN Code) are now visible. Scroll right to see them.",
    "Destination": "Destination",
    "Delete All Shipments Alert": "This will delete ALL {{count}} shipment(s). This action cannot be undone.",
    "Delete All Shipments": "Delete All Shipments",
    "Delete Selected ({{count}})": "Delete Selected ({{count}})",
    "Delete All ({{count}})": "Eliminar Todos ({{count}})",
    "Delete Selected Shipments": "Delete Selected Shipments",
    "Delete Selected Shipments Alert": "This will delete {{count}} shipment(s). This action cannot be undone.",
    "Invalid Cargo Description. Please enter a specific mechandise description": "Invalid Cargo Description. Please enter a specific mechandise description.",
    "View only access": "View-only access. Cannot edit or submit trips.",
    "Allows access to edit catalogs": "Allows access to edit catalogs",
    "Limits visibility to own trips only": "Limits visibility to own trips only",
    "Read Only": "Read Only",
    "Catalog Edition": "Catalog Edition",
    "Restricted": "Restricted",
}

export default data;